import React from 'react'
import { isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle, withProps } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

// import from './../selectors/user.js'
import { fetchingState } from './../helpers/hocs.js'
import { get, send } from '../store/reducers/feedback'

import Form from './../components/Form'
import Select from './../components/Select'
import Loader from './Loader'

// {data.name && <span className='Contacts-form__underhead Text'>{data.name} {data.contact && data.contact} {(data.topic && topics[data.topic]) && topics[data.topic]}</span>}

const ContactsForm = ({ success = null, topics, data = {}, tmpData, setData, peoceed, fetching, submit, intl, errors, error }) => (
  <div className='Contacts-form__body'>
    {
      success ? <div className='Contacts-form__title Head'>
        <FormattedMessage id='contacts_form.message_sent' />
      </div>
        : (
          <div>
            <h1 className='Contacts-form__title Head'>
              <FormattedMessage id='contacts_form.write_message' />
            </h1>
            {!fetching.info && (
              <div>
                {!data.name && <Form value={tmpData.name} onInput={setData('name')} placeholder={intl.formatMessage({id: 'contacts_form.name'})} onSubmit={peoceed.bind(this, 'name')} />}
                {((data.name && !data.contact) || errors.contact) && (
                  <div>
                  <Form value={tmpData.contact} onInput={setData('contact')} placeholder={intl.formatMessage({id: 'contacts_form.phone'})} onSubmit={ peoceed.bind(this, 'contact') } />
                  {errors && errors.contact && <div className='PaymentMethod__title'>Отсутствует/некорректный номер телефона</div>}
                </div>
                )
                }
                {(data.contact && !data.topic && !errors.contact) && <Select value={tmpData.topic} items={topics} onSubmit={peoceed.bind(this, 'topic')} required/>}
                {(data.topic && !errors.contact) && <Form value={tmpData.message} onInput={setData('message')} placeholder={intl.formatMessage({id: 'contacts_form.message'})} onSubmit={submit} />}
              </div>
            )}

            {(fetching.send || fetching.info) && <Loader isLight />}
            {!isNil(success) && <div className='Text'>
              <FormattedMessage id='contacts_form.error' />
            </div>}
          </div>
        )
    }
  </div>
)

const mapStateToProps = state => ({ ...state.feedback })

const mapDispatchToProps = dispatch => bindActionCreators({ get, send }, dispatch)

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('data', 'setData', {}),
  withState('tmpData', 'setTmpData', {}),
  withState('success', 'setSuccess', null),
  withState('errors', 'setErrors', {}),
  withState('error', 'setError', ''),
  fetchingState({ multi: true }),
  withHandlers({
    get: ({ get, fetchingWrap }) => () => fetchingWrap(get.bind(this), 'info'),
    setData: ({ setTmpData, tmpData, errors, setErrors }) => field => e => {
      tmpData[field] = e
      if(field === "contact") {
        if (!tmpData[field]) {
          errors.contact = 'Необходимо указать номер телефона'
        } else if (tmpData[field]) {
          //var re = /^\d[\d\(\)\ -]{9,9}\d$/;
          var re = /^\d+$/;
          var valid = re.test(tmpData[field]);
          if (!valid || tmpData[field].length < 10) {
            errors.contact = 'Номер телефона введен некорректно!'
          } else if (valid && tmpData[field].length >= 10){
            delete errors.contact;
          }
        }
        setErrors(errors)
      }
      setTmpData(tmpData)
    },
    clearData: ({ setData }) => () => {
      setData({})
    },
    peoceed: ({ setData, data, setTmpData, tmpData, errors }) => (field, e) => {
      e && e.preventDefault && e.preventDefault()
      data[field] = field === 'topic' ? e : tmpData[field]
      if (errors && !errors.contact)  setData(data) 
      if (field === 'topic') setTmpData({ ...tmpData, [field]: e })
    },
    submit: ({ send, info, tmpData, data, setSuccess, fetchingWrap, setError, setErrors, errors }) => async e => {
      e && e.preventDefault()
      setSuccess(null)
      data = { ...info, ...tmpData, topic: data.topic }
      //let errors = {};
      setErrors(errors)
      if (Object.keys(errors).length === 0) {
        const result = await fetchingWrap(send.bind(this, data), 'send')
        if (result === 200) {
          setSuccess(true)
          setError('')
        } else {
          setSuccess(true)
          setError('Ошибка')
        }
      }
    }
  }),
  withProps(props => ({
    data: { ...props.info, ...props.data },
    tmpData: { ...props.info, ...props.tmpData }
  })),
  lifecycle({
    componentWillMount () {
      this.props.clearData()
      this.props.setTmpData({})
      this.props.get()
    },
    componentWillUnmount () {
      this.props.setTmpData({})
      this.props.setSuccess(null)
      this.props.clearData()
    }
  })
)(ContactsForm))



// WEBPACK FOOTER //
// ./src/components/ContacsForm.jsx